export const MDM_GROUPS = {
  ADD_GROUP: 'Agregar Grupo',
  NO_GROUPS: 'No se encontraron grupos',
  HOSTS: 'dispositivos',
  POLICIES: 'Políticas',
  POLICIES_COUNT: (count: number) => `Políticas (${count})`,
  NO_POLICIES: 'Sin políticas',
  BASELINE_COMPLIANCE: 'Cumplimiento base',
  COMPLIANT_HOSTS: (compliant: number, total: number) =>
    `${compliant}/${total} ${total === 1 ? 'dispositivo' : 'dispositivos'}`,
  SUMMARY: (groups: number, assigned: number, total: number) =>
    `${groups} ${groups === 1 ? 'grupo' : 'grupos'} · ${assigned} de ${total} ${total === 1 ? 'dispositivo asignado' : 'dispositivos asignados'}`,
  HOSTS_COUNT: (count: number) => `Dispositivos (${count})`,
  NO_DEVICES: 'No hay dispositivos en este grupo',
  GROUP_DETAILS: 'Detalles del Grupo',
  NEW_GROUP: 'Nuevo Grupo',
  CREATE_GROUP: 'Crear Grupo',
  CANCEL: 'Cancelar',
  NAME: 'Nombre',
  DESCRIPTION: 'Descripción',
  PLATFORM: 'Plataforma',
  ENTER_GROUP_NAME: 'Ingrese el nombre del grupo',
  ENTER_GROUP_DESCRIPTION: 'Ingrese la descripción del grupo',
  TITLE: 'Grupos',
  SELECT_HOSTS: 'Seleccionar dispositivos',
  ADD_MORE_HOSTS: 'Agregar más dispositivos',
  SEARCH_HOSTS: 'Buscar dispositivos...',
  LOADING_HOSTS: 'Cargando dispositivos...',
  NO_HOSTS_FOUND: 'No se encontraron dispositivos',
  NO_HOSTS_FOR_PLATFORM: 'No hay dispositivos para esta plataforma',
}

export const MDM_GROUPS_MESSAGES = {
  CREATED: 'Grupo creado correctamente',
  FAILED_TO_CREATE: 'Error al crear el grupo',
  NAME_CONFLICT: (name: string) => `Ya existe un grupo con el nombre "${name}", elige otro nombre.`,
}

export const MDM_GROUPS_DELETE_DIALOG = {
  TITLE: 'Eliminar Grupo',
  QUESTION: '¿Estás seguro de que deseas eliminar',
  CONFIRMATION: 'Esta acción no se puede deshacer.',
  CANCEL: 'Cancelar',
  DELETE: 'Eliminar',
}

export const MDM_GROUPS_PLATFORMS = {
  MACOS: 'macOS',
  WINDOWS: 'Windows',
  LINUX: 'Linux',
  IOS: 'iOS',
  ANDROID: 'Android',
  ALL: 'Todos',
  ALL_PLATFORMS: 'Todas las Plataformas',
}
